import React from 'react'
import Chip from '@mui/material/Chip'
import PublicIcon from '@mui/icons-material/Public'
import NotListedLocationIcon from '@mui/icons-material/NotListedLocation'
import { Tooltip, Zoom } from '@mui/material'

interface ComponentProps {
  countryCode: string | undefined | null
}

export const CountryChip: React.FC<ComponentProps> = ({ countryCode }: ComponentProps): JSX.Element => {
  let variant: 'outlined' | undefined
  let color: 'primary' | 'warning' | 'error' | 'secondary' | 'success' | undefined

  if (countryCode === 'US') {
    color = 'error'
    variant = undefined
  } else {
    variant = 'outlined'
  }

  const renderIcon = (code: string | undefined | null): JSX.Element => {
    if (code === '-' || code === null || code === undefined) {
      return <NotListedLocationIcon />
    } else {
      return <PublicIcon />
    }
  }

  return (
    <>
      <Tooltip title={countryCode} TransitionComponent={Zoom} arrow placement='bottom'>
      {variant === undefined || variant === null
        ? (
          <Chip icon={renderIcon(countryCode)} label={countryCode} color={color} />
          )
        : (
          <Chip icon={renderIcon(countryCode)} label={countryCode} variant={variant} color={color} />
          )
      }
      </Tooltip>
    </>
  )
}
